import {
    SmallTextHelper,
} from '../../PrismicHelpers';

export const coursesSlice = (data) => {

    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    const sliceRepetableData = data.items;
    
    const moduleIds = sliceRepetableData.map(modules => {
        return modules.module_name.id
    })
    
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        modules: moduleIds
    };
    return dataToSend;
}

export const coursesSliceRelationship = (data, sliceType) => {
    
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = sliceType;
    const sliceRepetableData = data.results;
    
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        modules: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            return {
                id: SmallTextHelper(element.id),
                name: SmallTextHelper(element.data.module_name),
                description: SmallTextHelper(element.data.module_description),
                trailer_url: SmallTextHelper(element.data.trailer_url),
                worksheet_url: SmallTextHelper(element.data.worksheet_url)
            }
        })
    };
    return dataToSend
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/coursesSlice.js